import { defineComponent as _defineComponent } from 'vue'
import PasswordSetting from '@/views/settings/components/settings/PasswordSetting.vue';
import TwoFactorAuthSettings from '@/views/settings/components/settings/TwoFactorUsageSetting.vue';
import TwoFactorMethodSetting from '@/views/settings/components/settings/TwoFactorMethodSetting.vue';
import MobileNumberSetting from '@/views/settings/components/settings/MobileNumberSetting.vue';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionSecurity',
  setup(__props) {

const { isGuest } = useUser('self');


return { __sfc: true,isGuest, PasswordSetting, TwoFactorAuthSettings, TwoFactorMethodSetting, MobileNumberSetting }
}

})